module.exports = __webpack_public_path__ + "img/2x.8e6a7c2.jpg";